import { registerQuery } from 'data-fetching-client';
import { getInAppPhoneNumberRpc } from 'growth-monetization-service-types';
import http from 'hub-http/clients/apiClient';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import { getPublicPhoneNumberV2Rpc } from 'pricing-pages-api/__generated__/chirp/com/hubspot/buying/rpc/PublicProductRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import { getChirpEarlyRequest, getEarlyRequestResult } from '../utils/earlyRequest';

// ******************* Public ***********************
const rpcClientNoAuth = createRpcClientV2({
  hubHttpClient: noAuthHttp
});
export const GET_PUBLIC_PHONE_NUMBER_V2 = registerQuery({
  fieldName: 'phoneNumber',
  args: ['browserLocale', 'preferredCountryCode'],
  fetcher({
    browserLocale,
    preferredCountryCode
  }) {
    const request = {
      browserLocale,
      preferredCountryCode: preferredCountryCode
    };
    return getChirpEarlyRequest({
      details: Object.assign({}, getPublicPhoneNumberV2Rpc, {
        earlyRequest: true
      }),
      requestObject: {
        request
      },
      fallbackFetcher: () => rpcClientNoAuth.call(getPublicPhoneNumberV2Rpc, {
        request
      })
    });
  }
});

// ******************* In-App ***********************
const rpcClientAuth = createRpcClientV2({
  hubHttpClient: http
});
export const GET_PHONE_NUMBER = registerQuery({
  fieldName: 'phoneNumber',
  args: ['earlyRequestName', 'preferredLanguage'],
  fetcher({
    earlyRequestName,
    preferredLanguage
  }) {
    return getEarlyRequestResult(earlyRequestName, () => rpcClientAuth.call(getInAppPhoneNumberRpc, {
      pathParameters: {
        preferredLanguage
      }
    }));
  }
});